export default "__VITE_ASSET__6b9ff279__"